import axios from 'axios';
import apiConfig from '../shared/config/api.config';

export default function chainHotelsRequest(chainId) {
  const {
    host,
    URIs: { chainHotels },
  } = apiConfig;

  const uri = `${host}${chainHotels}`.replace(':chainId', chainId);

  return axios.get(uri).then(res => {
    return res.data;
  });
}
